import React, { createContext, useState, useContext, useMemo } from 'react';

export interface TabContextType {
    currentTab: string;
    setCurrentTab: (tab: string) => void;
    registerTab: (name: string) => void;
    tabNames: string[];
}

const TabContext = createContext<TabContextType | undefined>(undefined);

export function TabPanelProvider({ children, initialTab }: { children: React.ReactNode; initialTab: string }) {
    const [currentTab, setCurrentTab] = useState(initialTab);
    const [tabNames, setTabNames] = useState<string[]>([]);

    const registerTab = (name: string) => {
        setTabNames((prev) => (prev.includes(name) ? prev : [...prev, name]));
    };

    const values = useMemo(() => ({ currentTab, setCurrentTab, registerTab, tabNames }), [currentTab, tabNames]);

    return <TabContext.Provider value={values}>{children}</TabContext.Provider>;
}

export function useTabPanelContext() {
    const context = useContext(TabContext);
    if (!context) {
        throw new Error('useTabPanelContext must be used within a TabPanelProvider');
    }
    return context;
}
